import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Gym.svg",
  "use": "Gym.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Gym.svg\"><path d=\"M58,35h0v8a1,1,0,0,1-1,1H55a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v8h0a2,2,0,0,1,2,2v2A2,2,0,0,1,58,35ZM50,48H48a2,2,0,0,1-2-2V35H18V46a2,2,0,0,1-2,2H14a2,2,0,0,1-2-2V18a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V29H46V18a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V46A2,2,0,0,1,50,48ZM9,44H7a1,1,0,0,1-1-1V35H6a2,2,0,0,1-2-2V31a2,2,0,0,1,2-2H6V21a1,1,0,0,1,1-1H9a1,1,0,0,1,1,1V43A1,1,0,0,1,9,44Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol